<template>
  <div ref="checkboxDropdown" class="dropdown">
    <button v-if="color==='teal'" class="btn-regular" :class="{teal : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <button v-else class="btn-regular" :class="{pink : isSet, secondary : !isSet}" @click.stop="toggledDropdown">{{labelDropdown}}</button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown__menu" @click.stop="isShown = true">
        <div class="dropdown__menu__wrapper__loading" v-if="loading">
          <adx-loading/>
        </div>
        <div v-else>
        <div class="dropdown__menu__wrapper">
          <multiple-checkbox
            :value.sync="checkedItem"
            :options="list"
            :styleClass="`dropdown__menu__wrapper__sub__item`"
            :styleWrapperClass="`dropdown__menu__wrapper__sub`"
          />
        </div>
        <div class="dropdown__menu__footer">
          <span @click.stop="reset" class="dropdown__menu__footer__reset">Reset</span>
          <span @click.stop="apply" class="dropdown__menu__footer__apply">Apply</span>
        </div>
      </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
        <template slot="content">
          <div class="dropdown__menu" @click.stop="isShown = true">
            <div class="dropdown__menu__wrapper__loading" v-if="loading">
              <adx-loading/>
            </div>
            <div v-else>
            <div class="dropdown__menu__wrapper">
              <multiple-checkbox
                :value.sync="checkedItem"
                :options="list"
                :styleClass="`dropdown__menu__wrapper__sub__item`"
                :styleWrapperClass="`dropdown__menu__wrapper__sub`"
              />
            </div>
            <div class="dropdown__menu__footer">
              <span @click.stop="reset" class="dropdown__menu__footer__reset">Reset</span>
              <span @click.stop="apply" class="dropdown__menu__footer__apply">Apply</span>
            </div>
            </div>
          </div>
        </template>
      </modal>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import Checkbox from '@/components/Form/Checkbox'
import MultipleCheckbox from '@/components/Form/MultipleCheckbox'
import LoadingPrimary from '@/components/Loading/Primary'

export default {
  name: 'adx-dropdown-checkbox-custom',
  components: {
    'media': Media,
    'modal': Modal,
    'Checkbox': Checkbox,
    'multiple-checkbox': MultipleCheckbox,
    'adx-loading': LoadingPrimary,
  },
  props: {
    loading: {
      required: false,
      default: false,
    },
    list: {
      type: Array,
      required: true,
    },
    labelButton: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    default: {
      type: Array,
      required: false
    },
    color: {
      required: false,
      default: 'teal'
    }
  },
  data() {
    return {
      checkedItem: [],
      checkedItemFirst: [],
      isApply: false,
      isShown: false,
      // isSet: false,
      // labelDropdown: '',
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.checkedItem = this.default
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
      this.checkedItemFirst = this.checkedItem
      this.isApply = false
    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    apply() {
      this.isApply = true
      this.closeDropdown()
      this.$emit('selected', this.checkedItem)
    },
    applyWithoutClose() {
      this.isApply = true
      this.$emit('selected', this.checkedItem)
    },
    reset() {
      this.checkedItem = []
    },
  },
  watch: {
    default: function () {
      this.checkedItem = this.default
      this.apply()
    }
  },
  computed: {
    isSet: function () {
      return this.checkedItem.length > 0 ? true : false
    },
    labelDropdown: function () {
      return this.checkedItem.length > 0
        ? this.checkedItem.length + " • " + this.labelButton
        : this.labelButton
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>